import { ComponentIds, OutlinedComponent, Transform, TransformUtils, Vector, } from "@inter-ikea-core/core";
import { MountingRailConnectionService } from "../utils/ConnectorService";
import { getUprights } from "../utils/sectionsHelpers";
import { NO_UPRIGHTS, UPRIGHT_DOESNT_EXIST } from "../constants/errors";
import { findEntityInCatalog, getCatalogProductsByType, } from "./RecolorSolution";
import { indexMountingRailsInSolution } from "../utils/mountingRailHelpers";
import { createSnapAction } from "./MountingRails";
import { INVALID_SNAP_ACTION, NO_CONNECTION, } from "@inter-ikea-storagetwo/range/dist/constants/errors";
export const HEIGHTS = [1000, 2000];
export const findOtherHeight = (height) => HEIGHTS.find((h) => h !== height);
const restorePreviousPosition = (core, connection, entity) => {
    const oldPosition = TransformUtils.worldTransform(entity);
    const { guestConnector, hostConnector } = connection;
    return () => {
        TransformUtils.setWorldTransform(entity, oldPosition);
        const { errors, snap: restorationSnapActionCandidate, valid, } = createSnapAction(core, entity, guestConnector, connection.hostConnectorEntity, hostConnector);
        if (errors.length || !valid)
            throw new Error(INVALID_SNAP_ACTION);
        restorationSnapActionCandidate === null || restorationSnapActionCandidate === void 0 ? void 0 : restorationSnapActionCandidate.performMoveAndConnect();
        return { successful: false, snapActionCandidate: null };
    };
};
export const roomAvailableUpwards = (core, mountingRail, connection) => {
    const { X, Z } = TransformUtils.worldPosition(mountingRail);
    const newPosition = new Vector(X, 2000, Z);
    const newTransform = new Transform(newPosition);
    TransformUtils.setWorldTransform(mountingRail, newTransform);
    const snapResult = createSnapAction(core, mountingRail, connection.guestConnector, connection.hostConnectorEntity, connection.hostConnector);
    const successful = !snapResult.errors.length && snapResult.valid;
    return { successful, snapResult };
};
export const changeSectionHeight = (core, catalog, mountingRail) => {
    var _a;
    const { leftUpright, rightUpright } = getUprights(mountingRail);
    if (!leftUpright || !rightUpright)
        throw new Error(NO_UPRIGHTS);
    const indexedMountingRails = indexMountingRailsInSolution(mountingRail);
    const firstMountingRail = indexedMountingRails[0];
    const catalogData = findEntityInCatalog(catalog, leftUpright);
    const height = catalogData.template.comSize.height;
    const newHeight = findOtherHeight(height);
    const mountingRailVerticalPosition = TransformUtils.worldPosition(firstMountingRail).Y;
    const color = catalogData.meta.design;
    const uprightVariants = getCatalogProductsByType(catalog, catalogData.type);
    const newUprightData = uprightVariants.find(({ meta, template }) => {
        return meta.design === color && template.comSize.height === newHeight;
    });
    if (!newUprightData)
        throw new Error(UPRIGHT_DOESNT_EXIST);
    if (newHeight > mountingRailVerticalPosition) {
        const connectorService = MountingRailConnectionService(core);
        const connection = connectorService.disconnect(firstMountingRail);
        if (!connection)
            throw new Error(NO_CONNECTION);
        const positionRestoration = restorePreviousPosition(core, connection, firstMountingRail);
        const { successful, snapResult } = roomAvailableUpwards(core, firstMountingRail, connection);
        if (!successful) {
            positionRestoration();
            return;
        }
        (_a = snapResult.snap) === null || _a === void 0 ? void 0 : _a.performMoveAndConnect();
    }
    replaceUprightsInSolution(core, mountingRail, newUprightData.id);
};
export const replaceUprightsInSolution = (core, mountingRail, uprightId) => {
    const connectorService = MountingRailConnectionService(core);
    const { leftUpright, rightUpright } = getUprights(mountingRail);
    if (!leftUpright || !rightUpright)
        throw new Error(NO_UPRIGHTS);
    // This should be here, but something breaks the mounting rail when undoing height change.
    // core.modules.history()?.takeSnapshot("resizing section");
    const shouldOutline = [leftUpright, rightUpright].every((e) => e.hasComponent(ComponentIds.OUTLINED_COMPONENT_ID));
    const newLeftUpright = connectorService.replace(leftUpright).with(uprightId);
    const newRightUpright = connectorService
        .replace(rightUpright)
        .with(uprightId);
    if (shouldOutline)
        [newLeftUpright, newRightUpright].forEach((e) => e === null || e === void 0 ? void 0 : e.addComponent(new OutlinedComponent()));
};
